"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PG = void 0;
exports.PG = {
    numericCode: '598',
    alpha2Code: 'PG',
    alpha3Code: 'PNG',
    englishName: {
        short: 'Papua New Guinea',
        full: 'the Independent State of Papua New Guinea',
    },
    names: {
        full: {
            en: 'the Independent State of Papua New Guinea',
            fr: "l'État indépendant de Papouasie-Nouvelle-Guinée",
            ho: 'Papuaniugini',
            '': 'Papuaniugini',
        },
        short: {
            en: 'Papua New Guinea',
            fr: 'Papouasie-Nouvelle-Guinée (la)',
            ho: 'Papuaniugini',
            '': 'Papuaniugini',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'ho',
            languageAlpha3Code: 'hmo',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: '',
            languageAlpha3Code: 'tpi',
            isAdministrative: true,
        },
    ],
    subdivisions: {
        'PG-NCD': {
            numericCode: '598',
            code: 'PG-NCD',
            category: {
                id: '137',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    '': {
                        singular: 'distrik',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'National Capital District (Port Moresby)',
            },
        },
        'PG-CPK': {
            numericCode: '598',
            code: 'PG-CPK',
            category: {
                id: '173',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    '': {
                        singular: 'provins',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Chimbu',
            },
        },
        'PG-CPM': {
            numericCode: '598',
            code: 'PG-CPM',
            category: {
                id: '173',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    '': {
                        singular: 'provins',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Central',
            },
        },
        'PG-EBR': {
            numericCode: '598',
            code: 'PG-EBR',
            category: {
                id: '173',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    '': {
                        singular: 'provins',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'East New Britain',
            },
        },
        'PG-EHG': {
            numericCode: '598',
            code: 'PG-EHG',
            category: {
                id: '173',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    '': {
                        singular: 'provins',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Eastern Highlands',
            },
        },
        'PG-EPW': {
            numericCode: '598',
            code: 'PG-EPW',
            category: {
                id: '173',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    '': {
                        singular: 'provins',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Enga',
            },
        },
        'PG-ESW': {
            numericCode: '598',
            code: 'PG-ESW',
            category: {
                id: '173',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    '': {
                        singular: 'provins',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'East Sepik',
            },
        },
        'PG-GPK': {
            numericCode: '598',
            code: 'PG-GPK',
            category: {
                id: '173',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    '': {
                        singular: 'provins',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Gulf',
            },
        },
        'PG-HLA': {
            numericCode: '598',
            code: 'PG-HLA',
            category: {
                id: '173',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    '': {
                        singular: 'provins',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Hela',
            },
        },
        'PG-JWK': {
            numericCode: '598',
            code: 'PG-JWK',
            category: {
                id: '173',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    '': {
                        singular: 'provins',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Jiwaka',
            },
        },
        'PG-MBA': {
            numericCode: '598',
            code: 'PG-MBA',
            category: {
                id: '173',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    '': {
                        singular: 'provins',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Milne Bay',
            },
        },
        'PG-MPL': {
            numericCode: '598',
            code: 'PG-MPL',
            category: {
                id: '173',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    '': {
                        singular: 'provins',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Morobe',
            },
        },
        'PG-MPM': {
            numericCode: '598',
            code: 'PG-MPM',
            category: {
                id: '173',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    '': {
                        singular: 'provins',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Madang',
            },
        },
        'PG-MRL': {
            numericCode: '598',
            code: 'PG-MRL',
            category: {
                id: '173',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    '': {
                        singular: 'provins',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Manus',
            },
        },
        'PG-NIK': {
            numericCode: '598',
            code: 'PG-NIK',
            category: {
                id: '173',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    '': {
                        singular: 'provins',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'New Ireland',
            },
        },
        'PG-NPP': {
            numericCode: '598',
            code: 'PG-NPP',
            category: {
                id: '173',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    '': {
                        singular: 'provins',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Northern',
            },
        },
        'PG-SAN': {
            numericCode: '598',
            code: 'PG-SAN',
            category: {
                id: '173',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    '': {
                        singular: 'provins',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'West Sepik',
            },
        },
        'PG-SHM': {
            numericCode: '598',
            code: 'PG-SHM',
            category: {
                id: '173',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    '': {
                        singular: 'provins',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Southern Highlands',
            },
        },
        'PG-WBK': {
            numericCode: '598',
            code: 'PG-WBK',
            category: {
                id: '173',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    '': {
                        singular: 'provins',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'West New Britain',
            },
        },
        'PG-WHM': {
            numericCode: '598',
            code: 'PG-WHM',
            category: {
                id: '173',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    '': {
                        singular: 'provins',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Western Highlands',
            },
        },
        'PG-WPD': {
            numericCode: '598',
            code: 'PG-WPD',
            category: {
                id: '173',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    '': {
                        singular: 'provins',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Western',
            },
        },
        'PG-NSB': {
            numericCode: '598',
            code: 'PG-NSB',
            category: {
                id: '186',
                names: {
                    en: {
                        singular: 'autonomous region',
                        plural: 'autonomous regions',
                    },
                    fr: {
                        singular: 'région autonome',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Bougainville',
            },
        },
    },
    cities: [
        {
            name: 'Wewak',
            subdivision: 'East Sepik',
        },
        {
            name: 'Port Moresby',
            subdivision: 'National Capital',
        },
        {
            name: 'Popondetta',
            subdivision: 'Northern Province',
        },
        {
            name: 'Mount Hagen',
            subdivision: 'Western Highlands',
        },
        {
            name: 'Mendi',
            subdivision: 'Southern Highlands',
        },
        {
            name: 'Madang',
            subdivision: 'Madang',
        },
        {
            name: 'Lae',
            subdivision: 'Morobe',
        },
        {
            name: 'Kokopo',
            subdivision: 'East New Britain',
        },
        {
            name: 'Kimbe',
            subdivision: 'West New Britain',
        },
        {
            name: 'Goroka',
            subdivision: 'Eastern Highlands',
        },
        {
            name: 'Daru',
            subdivision: 'Western Province',
        },
        {
            name: 'Bulolo',
            subdivision: 'Morobe',
        },
        {
            name: 'Arawa',
            subdivision: 'Bougainville',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUEcuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY291bnRyaWVzL2RhdGEvUEcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7O0dBSUc7OztBQU1VLFFBQUEsRUFBRSxHQUFZO0lBQ3ZCLFdBQVcsRUFBRSxLQUFLO0lBQ2xCLFVBQVUsRUFBRSxJQUFJO0lBQ2hCLFVBQVUsRUFBRSxLQUFLO0lBQ2pCLFdBQVcsRUFBRTtRQUNULEtBQUssRUFBRSxrQkFBa0I7UUFDekIsSUFBSSxFQUFFLDJDQUEyQztLQUNwRDtJQUNELEtBQUssRUFBRTtRQUNILElBQUksRUFBRTtZQUNGLEVBQUUsRUFBRSwyQ0FBMkM7WUFDL0MsRUFBRSxFQUFFLGlEQUFpRDtZQUNyRCxFQUFFLEVBQUUsY0FBYztZQUNsQixFQUFFLEVBQUUsY0FBYztTQUNyQjtRQUNELEtBQUssRUFBRTtZQUNILEVBQUUsRUFBRSxrQkFBa0I7WUFDdEIsRUFBRSxFQUFFLGdDQUFnQztZQUNwQyxFQUFFLEVBQUUsY0FBYztZQUNsQixFQUFFLEVBQUUsY0FBYztTQUNyQjtLQUNKO0lBQ0QsU0FBUyxFQUFFO1FBQ1A7WUFDSSxrQkFBa0IsRUFBRSxJQUFJO1lBQ3hCLGtCQUFrQixFQUFFLEtBQUs7WUFDekIsZ0JBQWdCLEVBQUUsSUFBSTtTQUN6QjtRQUNEO1lBQ0ksa0JBQWtCLEVBQUUsSUFBSTtZQUN4QixrQkFBa0IsRUFBRSxLQUFLO1lBQ3pCLGdCQUFnQixFQUFFLEtBQUs7U0FDMUI7UUFDRDtZQUNJLGtCQUFrQixFQUFFLElBQUk7WUFDeEIsa0JBQWtCLEVBQUUsS0FBSztZQUN6QixnQkFBZ0IsRUFBRSxJQUFJO1NBQ3pCO1FBQ0Q7WUFDSSxrQkFBa0IsRUFBRSxFQUFFO1lBQ3RCLGtCQUFrQixFQUFFLEtBQUs7WUFDekIsZ0JBQWdCLEVBQUUsSUFBSTtTQUN6QjtLQUNKO0lBQ0QsWUFBWSxFQUFFO1FBQ1YsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLDBDQUEwQzthQUNqRDtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFFBQVE7YUFDZjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFNBQVM7YUFDaEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxXQUFXO3FCQUN0QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsU0FBUzt3QkFDbkIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxrQkFBa0I7YUFDekI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxXQUFXO3FCQUN0QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsU0FBUzt3QkFDbkIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxtQkFBbUI7YUFDMUI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxXQUFXO3FCQUN0QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsU0FBUzt3QkFDbkIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxNQUFNO2FBQ2I7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxXQUFXO3FCQUN0QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsU0FBUzt3QkFDbkIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxZQUFZO2FBQ25CO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsV0FBVztxQkFDdEI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFNBQVM7d0JBQ25CLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsTUFBTTthQUNiO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsV0FBVztxQkFDdEI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFNBQVM7d0JBQ25CLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsTUFBTTthQUNiO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsV0FBVztxQkFDdEI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFNBQVM7d0JBQ25CLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsUUFBUTthQUNmO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsV0FBVztxQkFDdEI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFNBQVM7d0JBQ25CLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsV0FBVzthQUNsQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFFBQVE7YUFDZjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFFBQVE7YUFDZjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLE9BQU87YUFDZDtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGFBQWE7YUFDcEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxXQUFXO3FCQUN0QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsU0FBUzt3QkFDbkIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxVQUFVO2FBQ2pCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsV0FBVztxQkFDdEI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFNBQVM7d0JBQ25CLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsWUFBWTthQUNuQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLG9CQUFvQjthQUMzQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGtCQUFrQjthQUN6QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLG1CQUFtQjthQUMxQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFNBQVM7YUFDaEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLG9CQUFvQjtxQkFDL0I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxpQkFBaUI7d0JBQzNCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsY0FBYzthQUNyQjtTQUNKO0tBQ0o7SUFDRCxNQUFNLEVBQUU7UUFDSjtZQUNJLElBQUksRUFBRSxPQUFPO1lBQ2IsV0FBVyxFQUFFLFlBQVk7U0FDNUI7UUFDRDtZQUNJLElBQUksRUFBRSxjQUFjO1lBQ3BCLFdBQVcsRUFBRSxrQkFBa0I7U0FDbEM7UUFDRDtZQUNJLElBQUksRUFBRSxZQUFZO1lBQ2xCLFdBQVcsRUFBRSxtQkFBbUI7U0FDbkM7UUFDRDtZQUNJLElBQUksRUFBRSxhQUFhO1lBQ25CLFdBQVcsRUFBRSxtQkFBbUI7U0FDbkM7UUFDRDtZQUNJLElBQUksRUFBRSxPQUFPO1lBQ2IsV0FBVyxFQUFFLG9CQUFvQjtTQUNwQztRQUNEO1lBQ0ksSUFBSSxFQUFFLFFBQVE7WUFDZCxXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLEtBQUs7WUFDWCxXQUFXLEVBQUUsUUFBUTtTQUN4QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFFBQVE7WUFDZCxXQUFXLEVBQUUsa0JBQWtCO1NBQ2xDO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsT0FBTztZQUNiLFdBQVcsRUFBRSxrQkFBa0I7U0FDbEM7UUFDRDtZQUNJLElBQUksRUFBRSxRQUFRO1lBQ2QsV0FBVyxFQUFFLG1CQUFtQjtTQUNuQztRQUNEO1lBQ0ksSUFBSSxFQUFFLE1BQU07WUFDWixXQUFXLEVBQUUsa0JBQWtCO1NBQ2xDO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsUUFBUTtZQUNkLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsT0FBTztZQUNiLFdBQVcsRUFBRSxjQUFjO1NBQzlCO0tBQ0o7Q0FDSixDQUFBIn0=